import React from 'react';

function ResultsTracker() {
    return (
        <div className="flex-1 flex items-center justify-center p-8">
            <h2 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-400">
                Coming Soon
            </h2>
        </div>
    );
}

export default ResultsTracker;

